const module = 'user-group'
const user = 'user'

export default {
  group: `/${module}/group`,
  userAll: `/${module}/${user}/all`,
  userIbes: `/${module}/${user}/ibes`,
  userTracker: `/${module}/${user}/tracker`,
}